/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class APPVersionApi {
    static getInstance() {
        if (!this.instance) this.instance = new APPVersionApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取APP版本列表
    async getAPPVersionList (param,num,size){
        let url = `/api/sys/tenant/app/release/listPages?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增版本信息
    async addAPPVersion (param){
        let url = `/api/sys/tenant/app/release`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 取消版本信息
    async cancelAPPVersion (user_id, id){
        let url = `/api/sys/tenant/app/release/${user_id}/cancel/${id}`
        let result = await this.getData(url,{},'POST')
        return result
    }

     // 获取租户
     async getTenant (param){
        let url = `/api/sys/tenant/dropdown/query`
        let result = await this.getData(url,param,'POST')
        return result
    }


}

export {
    APPVersionApi
}